// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_m6-0";
export var buttonContainer = "_m6-3";
export var cancelButton = "_m6-4";
export var headerSection = "_m6-6";
export var headerTitle = "_m6-9";
export var messageSideLeft = "_m6-1";
export var messageSideRight = "_m6-2";
export var orderNumberContainer = "_m6-7";
export var orderNumberLabel = "_m6-8";
export var submitButton = "_m6-5";